// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1SESo","productName":"Table_productName__1VmY0"};